import React from 'react'
import PropTypes from 'prop-types'
import FadeIn from '../../../../components/molecules/Transitions/FadeIn'
import SuggestionChip from '../common/SuggestionChip'
import FlexRow from '../../../../components/molecules/FlexRow'

const SUGGESTION_PROMPTS = [
  'Show me top clients by AUM',
  'Do I have any client concentration risk?',
  'How should I use Denali AI?',
  'What are our most significant growth opportunities?',
  'Find clients with risk indicators',
  'What are the most significant risk indicators for my business?'
]

function SuggestionList ({ onSuggestionClick, suggestions, take }) {
  return (
    <FadeIn delay={0.5} duration={1}>
      <FlexRow className='gap-sm flex-wrap justify-center'>
        {suggestions.slice(0, take).map((prompt, index) => (
          <SuggestionChip
            key={index}
            className='w-full mx-2'
            onClick={() => onSuggestionClick?.(prompt)}
          >
            {prompt}
          </SuggestionChip>
        ))}
      </FlexRow>
    </FadeIn>
  )
}

SuggestionList.propTypes = {
  onSuggestionClick: PropTypes.func,
  suggestions: PropTypes.arrayOf(PropTypes.string),
  take: PropTypes.number
}

SuggestionList.defaultProps = {
  suggestions: SUGGESTION_PROMPTS,
  take: 3
}

export default SuggestionList
